// IELTS Mock 9 — Academic Writing (table + two-part essay)
// Same shape as IELTS_DATA_WRITING in ../IeltsWriting.js. `mock` is forwarded to
// /api/scoring/writing-validate so it is checked against this mock's reference points.
const IELTS_MOCK9_WRITING = {
  title: "Academic Writing Practice Test 9",
  tasks: [
    {
      id: "task1",
      mock: 9,
      title: "Task 1: Report (20 min)",
      prompt:
        "The table shows the percentage of people aged 16–24 and people aged 65 and over in the country of Westmark who used five different sources of news in 2012 and 2024. Summarise the information by selecting and reporting the main features, and make comparisons where relevant.",
      image: "/images/ielts-mock9/writing_task1_news_sources.svg",
      minWords: 150,
      keywords: ["television", "newspaper", "radio", "website", "social media", "young", "older", "65", "percent", "proportion", "2012", "2024", "increas", "declin", "compar"],
      diagramType: "table"
    },
    {
      id: "task2",
      mock: 9,
      title: "Task 2: Essay (40 min)",
      prompt:
        "In many cities, historic buildings are being demolished to make way for modern housing and offices. Why is this happening? Should governments do more to protect historic buildings?",
      minWords: 250,
      keywords: ["historic", "building", "demolish", "heritage", "housing", "office", "developer", "land", "government", "protect", "preserv", "reason"]
    }
  ]
};

export default IELTS_MOCK9_WRITING;
